import React from "react";
import Card from "react-bootstrap/Card";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Aditya Mishra </span>
            from <span className="purple"> Mumbai, India.</span>
            <br /><span className="purple">Aditya</span> is an enigma.Who is he? What does he do? You might never know...<br />
                   Or he could simply be a <span className="purple">Computer Science student at the University of Mumbai,</span> with a heavy penchant for gaming in his spare time.
                              When he's not in a coffee shop learning new ways to build the <span className="purple">web,</span> you can find him Running,Cycling along the beautiful mountain trail.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <i className="far fa-hand-point-right"></i> Playing Games
            </li>
            <li className="about-activity">
              <i className="far fa-hand-point-right"></i> Digital Art
            </li>
            <li className="about-activity">
              <i className="far fa-hand-point-right"></i> Digital Photography
            </li>
          </ul>

          <p style={{ marginBlockEnd: 0, color: "rgb(155 126 172)" }}>
          "This Is My Story Not Yours. You Must Let Me Finish Telling It."{" "}
          </p>
          <footer className="blockquote-footer">Ciri</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
